const styles = {
  cardBgActive: {
    p: 3,
    background: "linear-gradient(180deg, #ECEAE5 0%, #FFFFFF 100%)",
    borderRadius: 4,
  },
  cardBgInactive: (completed: boolean, isFirstIndex: boolean) => ({
    borderTop: isFirstIndex ? "none" : `1px solid`,
    borderColor: "purple.light",
    p: 3,
    backgroundColor: "white",
    opacity: completed ? 1 : 0.5,
  }),
  stepNumber: {
    fontSize: 12,
    width: 25,
    height: 25,
    borderRadius: 20,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  stepNumberActive: {
    backgroundColor: "primary.main",
    color: "white",
  },
  stepNumberInactive: {
    backgroundColor: "white",
    color: "primary.main",
    border: `1px solid`,
    borderColor: "primary.main",
  },
  description: { fontSize: { xs: 12, md: 16 }, mb: 1 },
};

export default styles;
